(function () {
  'use strict';

  if (window.OrnateProductBadgeEngineLoaded) return;

  window.OrnateProductBadgeEngineLoaded = true;

  var STORAGE_KEY = 'ornate_delivery_zip';
  var refreshTimer = null;
  var observer = null;

  function normalize(value) {
    return String(value || '').trim();
  }

  function normalizeLower(value) {
    return normalize(value).toLowerCase();
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[character];
    });
  }

  function getStoredZip() {
    if (
      window.OrnateDeliveryZip &&
      typeof window.OrnateDeliveryZip.get === 'function'
    ) {
      var apiData = window.OrnateDeliveryZip.get();

      if (apiData && apiData.zip) {
        return normalize(apiData.zip);
      }
    }

    try {
      var raw = localStorage.getItem(STORAGE_KEY);

      if (!raw) return '';

      var data = JSON.parse(raw);

      if (
        !data ||
        !data.zip ||
        !data.expiresAt ||
        Date.now() > Number(data.expiresAt)
      ) {
        localStorage.removeItem(STORAGE_KEY);
        return '';
      }

      return normalize(data.zip);
    } catch (error) {
      return '';
    }
  }

  function parseRules() {
    var raw = window.OrnateProductBadgeRulesRaw || '';

    if (!raw) {
      return {
        priority_rules: [],
        rules: []
      };
    }

    try {
      var parsed = JSON.parse(raw);

      return {
        priority_rules: Array.isArray(parsed.priority_rules)
          ? parsed.priority_rules
          : [],
        rules: Array.isArray(parsed.rules)
          ? parsed.rules
          : []
      };
    } catch (error) {
      console.warn('Ornate product badge rules could not be parsed.', error);

      return {
        priority_rules: [],
        rules: []
      };
    }
  }

  function zipMatches(rule, zip) {
    if (!rule.zip_regex || !zip) return false;

    try {
      return new RegExp(rule.zip_regex).test(zip);
    } catch (error) {
      return false;
    }
  }

  function arrayIncludesNormalized(list, value) {
    if (!Array.isArray(list) || !list.length) return true;

    value = normalizeLower(value);

    return list.some(function (item) {
      return normalizeLower(item) === value;
    });
  }

  function hasRequiredTags(requiredTags, productTags) {
    if (!Array.isArray(requiredTags) || !requiredTags.length) {
      return true;
    }

    return requiredTags.every(function (requiredTag) {
      requiredTag = normalizeLower(requiredTag);

      return (
        requiredTag &&
        productTags.indexOf(requiredTag) !== -1
      );
    });
  }

  function contextMatches(rule, context) {
    if (!Array.isArray(rule.contexts) || !rule.contexts.length) {
      return true;
    }

    context = normalizeLower(context);

    return rule.contexts.some(function (item) {
      return normalizeLower(item) === context;
    });
  }

  function priceMatches(rule, priceInCents) {
    var price = Number(priceInCents || 0) / 100;
    var min = Number(rule.min_price || 0);
    var max = Number(rule.max_price || 0);

    return price >= min && (!max || price < max);
  }

  function buildBadge(rule) {
    var text = normalize(rule.text || rule.label);

    if (!text) return '';

    var textColor = rule.text_color || '#ffffff';
    var backgroundColor = rule.bg_color || '#c53f33';
    var borderColor = rule.border_color || backgroundColor;

    return (
      '<span class="product-badge product-badge--json" style="' +
        '--badge-text-color:' + escapeHtml(textColor) + ';' +
        '--badge-bg-color:' + escapeHtml(backgroundColor) + ';' +
        '--badge-border-color:' + escapeHtml(borderColor) + ';' +
        'color:' + escapeHtml(textColor) + ';' +
        'background:' + escapeHtml(backgroundColor) + ';' +
        'border-color:' + escapeHtml(borderColor) + ';' +
      '">' +
        escapeHtml(text) +
      '</span>'
    );
  }

  function showOnlyFallbackBadge2(fallbackTarget) {
    if (!fallbackTarget) return false;

    var badges = fallbackTarget.querySelectorAll('.product-badge');
    var hasBadge2 = false;

    badges.forEach(function (badge) {
      if (badge.classList.contains('product-badge--2')) {
        badge.hidden = false;
        badge.style.display = '';
        hasBadge2 = true;
      } else {
        badge.hidden = true;
        badge.style.display = 'none';
      }
    });

    fallbackTarget.hidden = !hasBadge2;

    return hasBadge2;
  }

  function resetFallbackBadges(fallbackTarget) {
    if (!fallbackTarget) return;

    fallbackTarget
      .querySelectorAll('.product-badge')
      .forEach(function (badge) {
        badge.hidden = false;
        badge.style.display = '';
      });
  }

  function getBadgesFromRuleList(ruleList, root, zip) {
    var context = root.dataset.badgeContext || 'card';
    var vendor = root.dataset.productVendor || '';
    var price = Number(root.dataset.productPrice || 0);

    var productTags = String(root.dataset.productTags || '')
      .split('||')
      .map(function (tag) {
        return normalizeLower(tag);
      })
      .filter(Boolean);

    var badges = [];
    var rules = Array.isArray(ruleList) ? ruleList : [];

    for (var index = 0; index < rules.length; index += 1) {
      var rule = rules[index];

      if (!contextMatches(rule, context)) continue;
      if (!zipMatches(rule, zip)) continue;
      if (!arrayIncludesNormalized(rule.vendors, vendor)) continue;
      if (!hasRequiredTags(rule.required_tags, productTags)) continue;
      if (!priceMatches(rule, price)) continue;

      var badgeHtml = buildBadge(rule);

      if (badgeHtml) {
        badges.push(badgeHtml);
      }
    }

    return badges;
  }

  function getJsonBadgesForRoot(root, rulesData, zip) {
    var priorityBadges = getBadgesFromRuleList(
      rulesData.priority_rules,
      root,
      zip
    );

    if (priorityBadges.length) {
      return priorityBadges;
    }

    return getBadgesFromRuleList(
      rulesData.rules,
      root,
      zip
    );
  }

  function updateMediaGalleryBadges(jsonBadges, shouldUseJson) {
    var galleryJsonContainer = document.querySelector(
      '[data-media-gallery-json-badges]'
    );

    var galleryFallbackContainer = document.querySelector(
      '[data-media-gallery-fallback-badges]'
    );

    var galleryParent = galleryJsonContainer
      ? galleryJsonContainer.closest(
          '[data-dynamic-variant-content="media-gallery-badges"]'
        )
      : null;

    if (!galleryJsonContainer || !galleryFallbackContainer) {
      return;
    }

    if (shouldUseJson && jsonBadges.length) {
      galleryJsonContainer.innerHTML =
        '<div class="media-gallery__badge_container">' +
          jsonBadges.join('') +
        '</div>';

      galleryJsonContainer.hidden = false;
      galleryFallbackContainer.hidden = true;

      if (galleryParent) {
        galleryParent.hidden = false;
      }

      return;
    }

    galleryJsonContainer.innerHTML = '';
    galleryJsonContainer.hidden = true;
    galleryFallbackContainer.hidden = false;

    if (galleryParent) {
      galleryParent.hidden = false;
    }
  }

  function applyBadgeToRoot(root, rulesData, zip) {
    if (!root || !root.matches('[data-product-badge-root]')) {
      return;
    }

    var context = root.dataset.badgeContext || 'card';
    var isProductContext = context === 'product';
    var shouldShowJsonInRoot = context !== 'product';

    var jsonTarget = root.querySelector('[data-json-badges]');
    var fallbackTarget = root.querySelector('[data-fallback-badges]');

    var jsonBadges = zip
      ? getJsonBadgesForRoot(root, rulesData, zip)
      : [];

    if (jsonBadges.length) {
      if (jsonTarget) {
        if (shouldShowJsonInRoot) {
          jsonTarget.innerHTML = jsonBadges.join('');
          jsonTarget.hidden = false;
        } else {
          jsonTarget.innerHTML = '';
          jsonTarget.hidden = true;
        }
      }

      showOnlyFallbackBadge2(fallbackTarget);
      root.hidden = false;

      if (isProductContext) {
        updateMediaGalleryBadges(jsonBadges, true);
      }

      root.dataset.badgeAppliedZip = zip;

      return;
    }

    if (jsonTarget) {
      jsonTarget.innerHTML = '';
      jsonTarget.hidden = true;
    }

    resetFallbackBadges(fallbackTarget);

    if (isProductContext) {
      updateMediaGalleryBadges([], false);
    }

    if (fallbackTarget && fallbackTarget.innerHTML.trim()) {
      fallbackTarget.hidden = false;
      root.hidden = false;
    } else {
      if (fallbackTarget) {
        fallbackTarget.hidden = true;
      }

      root.hidden = true;
    }

    root.dataset.badgeAppliedZip = zip;
  }

  function applyBadges(container) {
    var scope = container || document;
    var rulesData = parseRules();
    var zip = getStoredZip();
    var roots = [];

    if (
      scope.nodeType === 1 &&
      scope.matches &&
      scope.matches('[data-product-badge-root]')
    ) {
      roots.push(scope);
    }

    if (scope.querySelectorAll) {
      scope
        .querySelectorAll('[data-product-badge-root]')
        .forEach(function (root) {
          roots.push(root);
        });
    }

    roots.forEach(function (root) {
      applyBadgeToRoot(root, rulesData, zip);
    });
  }

  function refreshBadgesSoon(container) {
    window.clearTimeout(refreshTimer);

    refreshTimer = window.setTimeout(function () {
      applyBadges(container || document);
    }, 40);
  }

  function nodeContainsBadgeRoots(node) {
    if (!node || node.nodeType !== 1) {
      return false;
    }

    if (
      node.matches &&
      node.matches('[data-product-badge-root]')
    ) {
      return true;
    }

    return Boolean(
      node.querySelector &&
      node.querySelector('[data-product-badge-root]')
    );
  }

  function startBadgeObserver() {
    if (observer || !document.body) {
      return;
    }

    observer = new MutationObserver(function (mutations) {
      var shouldRefresh = false;

      for (
        var mutationIndex = 0;
        mutationIndex < mutations.length;
        mutationIndex += 1
      ) {
        var mutation = mutations[mutationIndex];

        for (
          var nodeIndex = 0;
          nodeIndex < mutation.addedNodes.length;
          nodeIndex += 1
        ) {
          if (nodeContainsBadgeRoots(mutation.addedNodes[nodeIndex])) {
            shouldRefresh = true;
            break;
          }
        }

        if (shouldRefresh) {
          break;
        }
      }

      if (shouldRefresh) {
        refreshBadgesSoon(document);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function initializeBadgeEngine() {
    applyBadges(document);
    startBadgeObserver();

    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () {
        applyBadges(document);
      }, {
        timeout: 1200
      });
    } else {
      window.setTimeout(function () {
        applyBadges(document);
      }, 80);
    }
  }

  document.addEventListener('ornate:zip-ready', function () {
    refreshBadgesSoon(document);
  });

  document.addEventListener('geo:ready', function () {
    refreshBadgesSoon(document);
  });

  document.addEventListener('on:variant:change', function (event) {
    if (!event.detail || !event.detail.variant) {
      return;
    }

    var variant = event.detail.variant;

    document
      .querySelectorAll(
        '[data-product-badge-root][data-badge-context="product"]'
      )
      .forEach(function (root) {
        root.dataset.productPrice = String(variant.price || 0);
      });

    refreshBadgesSoon(document);
  });

  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) {
      refreshBadgesSoon(document);
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    refreshBadgesSoon(event.target || document);
  });

  document.addEventListener('shopify:section:reorder', function () {
    refreshBadgesSoon(document);
  });

  document.addEventListener('shopify:block:select', function (event) {
    refreshBadgesSoon(event.target || document);
  });

  window.OrnateProductBadgeEngine = {
    refresh: function (container) {
      refreshBadgesSoon(container || document);
    },

    apply: function (container) {
      applyBadges(container || document);
    },

    getZip: getStoredZip
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeBadgeEngine,
      { once: true }
    );
  } else {
    initializeBadgeEngine();
  }
})();